module.exports = {
  NAVBAR_HEIGHT: 64,
};
